/* eslint-disable*/

import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import MFSips from '../MutualFunds/MFSips'
import BasketSIPs from '../MutualFundsBaskets/BasketSIPs'
import ShowAllMandate from '../Mandates/ShowAllMandate'

const MFsSIPs = () => {
  return (
    <>
      <div className='mx-auto max-w-[1128px]'>
        <h2 className='px-4 pb-3 pt-4 font-IBM text-lg font-semibold leading-6 text-black-950 lg:px-0 lg:text-xl'>
          My SIPs & Mandates
        </h2>
      </div>

      <div className='mx-auto max-w-[1128px]'>
        <Tabs defaultValue='Goals' className='relative mr-auto w-full'>
          <div className='px-4 lg:px-0'>
            <TabsList className='mx-auto grid h-12 max-w-[520px] grid-cols-3 rounded-full'>
              <TabsTrigger value='Goals' className='relative h-10 px-2 text-sm leading-5 md:px-4'>
                Goals
              </TabsTrigger>

              <TabsTrigger
                value='Mutual Funds'
                className='relative h-10 px-2 text-sm leading-5 md:px-4'
              >
                <span className='sm:hidden'>Funds</span>
                <span className='hidden sm:inline'>Mutual Funds</span>
              </TabsTrigger>

              <TabsTrigger
                value='Mandates'
                className='relative h-10 px-2 text-sm leading-5 md:px-4'
              >
                Mandates
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value='Goals'>
            <BasketSIPs />
          </TabsContent>

          <TabsContent value='Mutual Funds'>
            <MFSips />
          </TabsContent>

          <TabsContent value='Mandates'>
            <ShowAllMandate />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}

export default MFsSIPs
